import React from "react";
import PropTypes from "prop-types";

const DispatchAdd = ({ onClick }) => {
  return (
    <div
      id="addDispatch"
      onClick={() => onClick()}
      onKeyDown={() => onClick()}
      role="presentation"
    >
      <i className="fa fa-plus-square-o" aria-hidden="true" />
    </div>
  );
};

DispatchAdd.propTypes = {
  onClick: PropTypes.func
};

export default DispatchAdd;
